


// import React, { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import { logout } from "../../store/authSlice"; 
// import {
//   Container,
//   Box,
//   CircularProgress,
//   Typography,
//   Paper,
//   Button,
//   TextField,
//   Stack,
// } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { useNavigate } from "react-router-dom";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import api from "../../api/axiosInterceptor";
// import Cookies from "js-cookie";
// import { API_BASE_URL } from "../../config";
// import { useTranslation } from "react-i18next";

// export default function ProfilePage() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const token = useSelector((state) => state.auth.token);
//   const refreshToken = useSelector((state) => state.auth.refresh);
//   const { t } = useTranslation();

//   const [profile, setProfile] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [edit, setEdit] = useState(false);
//   const [form, setForm] = useState({});
//   const [saving, setSaving] = useState(false);
//   const [previewImage, setPreviewImage] = useState(null);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     severity: "success",
//     message: "",
//   });
//   const [logoutLoading, setLogoutLoading] = useState(false);

//   // Fields to display in order (labels now use i18n keys)
//   const fieldOrder = [
//     { key: "name", label: t("profile1.fields.name"), readOnly: true },
//     { key: "email", label: t("profile1.fields.email"), readOnly: true },
//     { key: "phone_number", label: t("profile1.fields.phone"), readOnly: true },
//     { key: "roles", label: t("profile1.fields.roles"), readOnly: true },
//     { key: "current_address", label: t("profile1.fields.currentAddress"), readOnly: false },
//     { key: "parmanent_address", label: t("profile1.fields.permanentAddress"), readOnly: false },
//     { key: "pan_number", label: t("profile1.fields.pan"), readOnly: false },
//     { key: "adhaar_number", label: t("profile1.fields.aadhaar"), readOnly: false },
//   ];

//   useEffect(() => {
//     if (token) {
//       fetchProfile();
//     } else {
//       navigate("/accounts");
//     }
//   }, [token, navigate]);

//   const fetchProfile = async () => {
//     setLoading(true);
//     try {
//       const res = await api.get("/auth/profile/");

//       if (res.status === 401) {
//         dispatch(logout());
//         navigate("/accounts");
//         return;
//       }

//       const data = res.data;
//       if (data.user) {
//         setProfile({
//           ...data.user,
//           current_address: data.current_address,
//           parmanent_address: data.parmanent_address,
//           pan_number: data.pan_number,
//           adhaar_number: data.adhaar_number,
//           profile_picture: data.profile_picture || null,
//         });
//       } else {
//         setSnackbar({
//           open: true,
//           severity: "error",
//           message: t("profile1.errors.fetchFail"),
//         });
//         setProfile(null);
//       }
//     } catch (error) {
//       console.error("Error fetching profile:", error);
//       if (error.response && error.response.status === 401) {
//         dispatch(logout());
//         navigate("/accounts");
//       } else {
//         setSnackbar({
//           open: true,
//           severity: "error",
//           message: t("profile1.errors.fetchFail"),
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleChange = (e) => {
//     setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleImageChange = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       if (file.size > 502400) {
//         setSnackbar({
//           open: true,
//           severity: "error",
//           message: t("profile1.errors.imageSize"),
//         });
//         e.target.value = "";
//         return;
//       }
//       setForm((prev) => ({ ...prev, profile_picture: file }));
//       setPreviewImage(URL.createObjectURL(file));
//     }
//   };

//   const handleEdit = () => {
//     setForm({ ...profile });
//     setEdit(true);
//     setPreviewImage(null);
//   };

//   const handleCancel = () => {
//     setEdit(false);
//     setForm({});
//     setPreviewImage(null);
//   };

//   const handleSave = async () => {
//     setSaving(true);
//     try {
//       let body;
//       let headers = {};
//       if (form.profile_picture instanceof File) {
//         body = new FormData();
//         Object.entries(form).forEach(([key, value]) => {
//           if (value !== null && value !== undefined) {
//             body.append(key, value);
//           }
//         });
//       } else {
//         body = JSON.stringify(form);
//         headers["Content-Type"] = "application/json";
//       }

//       const res = await api.patch("/auth/profile/", body, { headers });
//       if (res.status === 401) {
//         dispatch(logout());
//         navigate("/accounts");
//         return;
//       }

//       const data = res.data;
//       if (data.user) {
//         setProfile({
//           ...data.user,
//           current_address: data.current_address,
//           parmanent_address: data.parmanent_address,
//           pan_number: data.pan_number,
//           adhaar_number: data.adhaar_number,
//           profile_picture: data.profile_picture || null,
//         });
//         setEdit(false);
//         setPreviewImage(null);
//         setSnackbar({
//           open: true,
//           severity: "success",
//           message: t("profile1.success.update"),
//         });
//       } else {
//         const errMsg =
//           typeof data === "object"
//             ? Object.values(data).flat().join(" ")
//             : t("profile1.errors.updateFail");
//         setSnackbar({ open: true, severity: "error", message: errMsg });
//       }
//     } catch (error) {
//       console.error("Error saving profile:", error);
//       if (error.response && error.response.data) {
//         const errorData = error.response.data;
//         const errorMessage =
//           typeof errorData === "object"
//             ? Object.values(errorData).flat().join(" ")
//             : t("profile1.errors.updateFail");
//         setSnackbar({ open: true, severity: "error", message: errorMessage });
//       } else {
//         setSnackbar({
//           open: true,
//           severity: "error",
//           message: t("profile1.errors.updateFail"),
//         });
//       }
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleLogout = async () => {
//     setLogoutLoading(true);
//     try {
//       const refreshTokenToSend = refreshToken || Cookies.get("refresh_token");
//       if (!refreshTokenToSend)
//         throw new Error(t("profile1.errors.noRefreshToken"));

//       const response = await api.post("/auth/signout/", {
//         refresh: refreshTokenToSend,
//       });

//       if (response.status === 200) {
//         dispatch(logout());
//         setSnackbar({
//           open: true,
//           severity: "success",
//           message: t("profile1.success.logout"),
//         });
//         setTimeout(() => navigate("/accounts"), 1000);
//       } else {
//         throw new Error(t("profile1.errors.logoutFail"));
//       }
//     } catch (error) {
//       console.error("Error during logout:", error);
//       dispatch(logout());
//       setSnackbar({
//         open: true,
//         severity: "error",
//         message:
//           error.response?.data?.message ||
//           t("profile1.errors.logoutLocalFail"),
//       });
//       navigate("/accounts");
//     } finally {
//       setLogoutLoading(false);
//     }
//   };

//   const handleCloseSnackbar = (_, reason) => {
//     if (reason === "clickaway") return;
//     setSnackbar((prev) => ({ ...prev, open: false }));
//   };

//   if (loading) {
//     return (
//       <Container>
//         <Box display="flex" justifyContent="center" mt={8}>
//           <CircularProgress />
//         </Box>
//       </Container>
//     );
//   }

//   return (
//     <Container maxWidth="sm">
//       <Paper elevation={3} sx={{ p: 4, mt: 10, mb: 5, position: "relative" }}>
//         <Button
//           startIcon={<ArrowBackIcon />}
//           onClick={() => navigate(-1)}
//           sx={{
//             position: "absolute",
//             left: 16,
//             top: 16,
//             padding: "4px 8px",
//             fontSize: "1rem",
//           }}
//           variant="text"
//         >
//           {t("profile1.backBtn")}
//         </Button>
//         <Stack spacing={2} sx={{ mt: 3 }}>
//           <Typography variant="h5" align="center" gutterBottom>
//             {t("profile1.heading")}
//           </Typography>

//           {/* Profile Picture at top */}
//           {profile && (
//             <Box sx={{ mb: 2, textAlign: "center" }}>
//               <img
//                 src={
//                   previewImage
//                     ? previewImage
//                     : profile.profile_picture
//                     ? profile.profile_picture
//                     : "https://via.placeholder.com/100"
//                 }
//                 alt="Profile"
//                 style={{
//                   width: 120,
//                   height: 120,
//                   borderRadius: "50%",
//                   objectFit: "cover",
//                   border: "1px solid #ddd",
//                 }}
//               />
//               {edit && (
//                 <Button variant="outlined" component="label" sx={{ mt: 1 }}>
//                   {t("profile1.uploadBtn")}
//                   <input
//                     type="file"
//                     accept="image/*"
//                     hidden
//                     onChange={handleImageChange}
//                   />
//                 </Button>
//               )}
//             </Box>
//           )}

//           {/* Profile Fields */}
//           {profile ? (
//             fieldOrder.map(({ key, label, readOnly }) =>
//               edit && !readOnly ? (
//                 <TextField
//                   key={key}
//                   name={key}
//                   label={label}
//                   value={
//                     form[key] !== undefined ? form[key] : profile[key] || ""
//                   }
//                   onChange={handleChange}
//                   fullWidth
//                   margin="normal"
//                 />
//               ) : (
//                 <Box key={key} display="flex" alignItems="center">
//                   <Typography sx={{ fontWeight: 600, minWidth: 150 }}>
//                     {label}:
//                   </Typography>
//                   <Typography sx={{ ml: 2 }}>
//                     {String(profile[key] ?? "")}
//                   </Typography>
//                 </Box>
//               )
//             )
//           ) : (
//             <Typography>{t("profile1.noInfo")}</Typography>
//           )}

//           <Box display="flex" justifyContent="space-between" mt={2}>
//             {edit ? (
//               <>
//                 <Button
//                   variant="contained"
//                   color="primary"
//                   onClick={handleSave}
//                   disabled={saving}
//                 >
//                   {saving ? <CircularProgress size={24} /> : t("profile1.saveBtn")}
//                 </Button>
//                 <Button
//                   variant="outlined"
//                   color="secondary"
//                   onClick={handleCancel}
//                   disabled={saving}
//                 >
//                   {t("profile1.cancelBtn")}
//                 </Button>
//               </>
//             ) : (
//               <Button variant="contained" onClick={handleEdit}>
//                 {t("profile1.editBtn")}
//               </Button>
//             )}
//             <Button
//               variant="outlined"
//               color="error"
//               onClick={handleLogout}
//               disabled={logoutLoading}
//               startIcon={logoutLoading ? <CircularProgress size={16} /> : null}
//             >
//               {logoutLoading ? t("profile1.buttons.loggingOut") : t("profile1.buttons.logout")}
//             </Button>
//           </Box>
//         </Stack>
//       </Paper>
//       <SnackBarComponent
//         open={snackbar.open}
//         severity={snackbar.severity}
//         message={snackbar.message}
//         onClose={handleCloseSnackbar}
//       />
//     </Container>
//   );
// }



import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../store/authSlice"; 
import {
  Container,
  Box,
  CircularProgress,
  Typography,
  Paper,
  Button,
  TextField,
  Stack,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import api from "../../api/axiosInterceptor";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

export default function ProfilePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.auth.token);
  const refreshToken = useSelector((state) => state.auth.refresh);
  const { t } = useTranslation();

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });
  const [logoutLoading, setLogoutLoading] = useState(false);

  const fieldOrder = [
    { key: "name", label: t("profile1.fields.name"), readOnly: true },
    { key: "email", label: t("profile1.fields.email"), readOnly: true },
    { key: "phone_number", label: t("profile1.fields.phone"), readOnly: true },
    { key: "roles", label: t("profile1.fields.roles"), readOnly: true },
    { key: "current_address", label: t("profile1.fields.currentAddress"), readOnly: false },
    { key: "parmanent_address", label: t("profile1.fields.permanentAddress"), readOnly: false },
    { key: "pan_number", label: t("profile1.fields.pan"), readOnly: false },
    { key: "adhaar_number", label: t("profile1.fields.aadhaar"), readOnly: false },
  ];

  useEffect(() => {
    if (token) {
      fetchProfile();
    } else {
      navigate("/accounts");
    }
  }, [token, navigate]);

  const fetchProfile = async () => {
    setLoading(true);
    try {
      const res = await api.get("/auth/profile/");
      if (res.status === 401) {
        dispatch(logout());
        navigate("/accounts");
        return;
      }
      const data = res.data;
      if (data.user) {
        setProfile({
          ...data.user,
          current_address: data.current_address,
          parmanent_address: data.parmanent_address,
          pan_number: data.pan_number,
          adhaar_number: data.adhaar_number,
          profile_picture: data.profile_picture || null,
        });
      } else {
        setSnackbar({ open: true, severity: "error", message: t("profile1.errors.fetchFail") });
        setProfile(null);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        dispatch(logout());
        navigate("/accounts");
      } else {
        setSnackbar({ open: true, severity: "error", message: t("profile1.errors.fetchFail") });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 502400) {
        setSnackbar({ open: true, severity: "error", message: t("profile1.errors.imageSize") });
        e.target.value = "";
        return;
      }
      setForm((prev) => ({ ...prev, profile_picture: file }));
      setPreviewImage(URL.createObjectURL(file));
    }
  };

  const handleEdit = () => {
    setForm({ ...profile });
    setEdit(true);
    setPreviewImage(null);
  };

  const handleCancel = () => {
    setEdit(false);
    setForm({});
    setPreviewImage(null);
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      let body;
      let headers = {};
      if (form.profile_picture instanceof File) {
        body = new FormData();
        Object.entries(form).forEach(([key, value]) => {
          if (key === "profile_picture" && value instanceof File) {
            body.append(key, value);
          } else if (key !== "profile_picture" && value !== null && value !== undefined) {
            body.append(key, value);
          }
        });
        // Do not set headers["Content-Type"] for FormData; Axios handles it
      } else {
        const { profile_picture, ...payload } = form;
        body = JSON.stringify(payload);
        headers["Content-Type"] = "application/json";
      }

      const res = await api.patch("/auth/profile/", body, { headers });
      if (res.status === 401) {
        dispatch(logout());
        navigate("/accounts");
        return;
      }
      const data = res.data;
      if (data.user) {
        setProfile({
          ...data.user,
          current_address: data.current_address,
          parmanent_address: data.parmanent_address,
          pan_number: data.pan_number,
          adhaar_number: data.adhaar_number,
          profile_picture: data.profile_picture || null,
        });
        setEdit(false);
        setPreviewImage(null);
        setSnackbar({ open: true, severity: "success", message: t("profile1.success.update") });
      } else {
        const errMsg = typeof data === "object" ? Object.values(data).flat().join(" ") : t("profile1.errors.updateFail");
        setSnackbar({ open: true, severity: "error", message: errMsg });
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        const errorMessage = typeof errorData === "object" ? Object.values(errorData).flat().join(" ") : t("profile1.errors.updateFail");
        setSnackbar({ open: true, severity: "error", message: errorMessage });
      } else {
        setSnackbar({ open: true, severity: "error", message: t("profile1.errors.updateFail") });
      }
    } finally {
      setSaving(false);
    }
  };

  const handleLogout = async () => {
    setLogoutLoading(true);
    try {
      const refreshTokenToSend = refreshToken || Cookies.get("refresh_token");
      if (!refreshTokenToSend) throw new Error(t("profile1.errors.noRefreshToken"));

      const response = await api.post("/auth/signout/", { refresh: refreshTokenToSend });
      if (response.status === 200) {
        dispatch(logout());
        setSnackbar({ open: true, severity: "success", message: t("profile1.success.logout") });
        setTimeout(() => navigate("/accounts"), 1000);
      } else {
        throw new Error(t("profile1.errors.logoutFail"));
      }
    } catch (error) {
      dispatch(logout());
      setSnackbar({ open: true, severity: "error", message: error.response?.data?.message || t("profile1.errors.logoutLocalFail") });
      navigate("/accounts");
    } finally {
      setLogoutLoading(false);
    }
  };

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  if (loading) {
    return (
      <Container>
        <Box display="flex" justifyContent="center" mt={8}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Paper elevation={3} sx={{ p: 4, mt: 10, mb: 5, position: "relative" }}>
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
          sx={{ position: "absolute", left: 16, top: 16, padding: "4px 8px", fontSize: "1rem" }}
          variant="text"
        >
          {t("profile1.backBtn")}
        </Button>
        <Stack spacing={2} sx={{ mt: 3 }}>
          <Typography variant="h5" align="center" gutterBottom>
            {t("profile1.heading")}
          </Typography>

          {/* Profile Picture */}
          {profile && (
            <Box sx={{ mb: 2, textAlign: "center" }}>
              <img
                src={
                  previewImage || profile.profile_picture || "https://via.placeholder.com/100"
                }
                alt="Profile"
                style={{ width: 120, height: 120, borderRadius: "50%", objectFit: "cover", border: "1px solid #ddd" }}
              />
              {edit && (
                <Button variant="outlined" component="label" sx={{ mt: 1 }}>
                  {t("profile1.uploadBtn")}
                  <input type="file" accept="image/*" hidden onChange={handleImageChange} />
                </Button>
              )}
            </Box>
          )}

          {/* Profile Fields */}
          {profile ? (
            fieldOrder.map(({ key, label, readOnly }) =>
              edit && !readOnly ? (
                <TextField
                  key={key}
                  name={key}
                  label={label}
                  value={form[key] !== undefined ? form[key] : profile[key] || ""}
                  onChange={handleChange}
                  fullWidth
                  margin="normal"
                />
              ) : (
                <Box key={key} display="flex" alignItems="center">
                  <Typography sx={{ fontWeight: 600, minWidth: 150 }}>{label}:</Typography>
                  <Typography sx={{ ml: 2 }}>{String(profile[key] ?? "")}</Typography>
                </Box>
              )
            )
          ) : (
            <Typography>{t("profile1.noInfo")}</Typography>
          )}

          <Box display="flex" justifyContent="space-between" mt={2}>
            {edit ? (
              <>
                <Button variant="contained" color="primary" onClick={handleSave} disabled={saving}>
                  {saving ? <CircularProgress size={24} /> : t("profile1.saveBtn")}
                </Button>
                <Button variant="outlined" color="secondary" onClick={handleCancel} disabled={saving}>
                  {t("profile1.cancelBtn")}
                </Button>
              </>
            ) : (
              <Button variant="contained" onClick={handleEdit}>{t("profile1.editBtn")}</Button>
            )}
            <Button
              variant="outlined"
              color="error"
              onClick={handleLogout}
              disabled={logoutLoading}
              startIcon={logoutLoading ? <CircularProgress size={16} /> : null}
            >
              {logoutLoading ? t("profile1.buttons.loggingOut") : t("profile1.buttons.logout")}
            </Button>
          </Box>
        </Stack>
      </Paper>
      <SnackBarComponent
        open={snackbar.open}
        severity={snackbar.severity}
        message={snackbar.message}
        onClose={handleCloseSnackbar}
      />
    </Container>
  );
}
